import { CategoriesMenuNode } from '@main/categories-menu/const';
import { StateUtils } from '@spartacus/core';

export const CATEGORIES_MENU_FEATURE = 'categories-menu';
export const CATEGORIES_MENU = '[Main Layout] Categories Menu';
export const CATEGORIES_MENU_ROOT_NODE_ID = '[Main Layout] Categories Menu Root Node Id';

export interface CategoriesMenuData {
  nodes: {
    [nodeId: string]: CategoriesMenuNode;
  };
  isOpen: boolean;
}

export interface StateWithCategoriesMenu {
  [CATEGORIES_MENU_FEATURE]: CategoriesMenuState;
}

export interface CategoriesMenuState {
  categoriesMenu: StateUtils.LoaderState<CategoriesMenuData>;
  rootNodeId: StateUtils.LoaderState<string>;
}
